import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cambio-domicilio-fiscal',
  templateUrl: './cambio-domicilio-fiscal.component.html',
  styleUrls: ['./cambio-domicilio-fiscal.component.css']
})
export class CambioDomicilioFiscalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
